import { atom, getDefaultStore } from 'jotai';

/**
 * Flag to signal that the next recommendation fetch should replace all cards
 * instead of merging with existing ones (used when PN toggle changes).
 */
export const freshFetchRequestedAtom = atom(false);

export function requestFreshFetch(): void {
  const store = getDefaultStore();
  store.set(freshFetchRequestedAtom, true);
}

export function consumeFreshFetchRequest(): boolean {
  const store = getDefaultStore();
  const wasRequested = store.get(freshFetchRequestedAtom);
  if (wasRequested) {
    store.set(freshFetchRequestedAtom, false);
  }
  return wasRequested;
}
